export default "__VITE_ASSET__2guJWZGa__"